/**
 * Split a tenant-relative path (optionally with ?search) into pathname + search
 * for React Router navigation targets.
 */
export function splitTenantRelativePath(path) {
  const cleanPath = String(path || '').startsWith('/')
    ? String(path).slice(1)
    : String(path || '');

  const qIndex = cleanPath.indexOf('?');
  if (qIndex === -1) {
    return { pathnamePart: cleanPath, search: '' };
  }

  return {
    pathnamePart: cleanPath.slice(0, qIndex),
    search: cleanPath.slice(qIndex),
  };
}

/**
 * @param {string} path tenant-relative path, e.g. "automations?tab=schedules&create=1"
 * @param {(path: string) => string} getTenantPath builds /{tenantSlug}/{path}
 */
export function buildTenantNavigationTarget(path, getTenantPath) {
  const { pathnamePart, search } = splitTenantRelativePath(path);
  return {
    pathname: getTenantPath(pathnamePart),
    search,
  };
}
